import React, { useState, useEffect } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'

import {
  withDataProvider,
  showNotification,
  GET_LIST
} from 'react-admin'

import { createStyles, WithStyles } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { ASSIGN_EXPERT } from '../../providers/constants'
import UsersSelect from '../UsersSelect'
import Cookies from 'js-cookie'
import ToolbarDirectorMo from "./ToolbarDirectorMo";
import ToolbarManagerMo from "./ToolbarManagerMo";
import ToolbarDeveloper from "./ToolbarDeveloper";
import ToolbarMethodist from "./ToolbarMethodist";


const styles = () => createStyles({
  wrap: {
    display: 'flex',
    width: '700px',
    marginBottom: '20px',
  },
  elements: {
    marginRight: '25px',
  },
  buttonWrap: {
    width: '596px',
    textAlign: 'right',
  },
  textAreaWrap: {
    marginBottom: '15px',
  },
  button: {
    marginRight: '15px'
  },
})

const responseSuccess = {
  onSuccess: {
    notification: { body: 'Сохранено', level: 'info' },
  },
  onFailure: {
    notification: { body: 'Error', level: 'warning' },
  },
  refresh: true
}

interface IProps extends WithStyles {
  dataProvider: any,
  segmentsId: [],
  permissions: any,
  checkedData: any,
  dispatch: any,
  setSegmentsId: any
}

const DashboardToolbarProvider = withStyles(styles)(({classes, dataProvider, segmentsId, checkedData, dispatch}: IProps) => {
  const [open, setOpen] = useState(false)
  const [showWarning, setShowWarning] = useState(false)
  const [warningContent, setWarningContent] = useState([])
  const [segmentErrors, setSegmentErrors] = useState([])
  const [assignButtonDisabled, setAssignButtonDisabled] = useState(true)
  const [selectedStatus, setSelectedStatus] = useState(0)
  const [selectedSpecId, setSelectedSpecId] = useState(0)
  const [currentUserId, setCurrentUserId] = useState(0)
  const [nextStatus, setNextStatus] = useState(0)
  const [download, setDownload] = useState(true)
  const [modalLabel, setModalLabel] = useState('')
  const [selectedAction, setSelectedAction] = useState(1)

  const [users, setUsers] = useState({
    experts: {},
    editors: {},
    nmo: {},
    mainNmo: {}
  })

  const role = Cookies.get('role')

  useEffect(() => {
    (async () => {
      // //Проверяем, выбран ли хотя бы один сегмент
      Object.keys(checkedData).length > 0 ? setAssignButtonDisabled(false) : setAssignButtonDisabled(true)

      const selectedStatuses = []
      const selectedModule = []

      Object.keys(checkedData).map((id, key) => {
        selectedStatuses.push(checkedData[id].statusId)
        if (checkedData[id].type === 'test') { selectedModule.push(checkedData[id].test.moduleId) } else { selectedModule.push(checkedData[id].case.moduleId) }
      })

      // Обрабатываем ошибки (сегменты находятся в разных статусах, принадлежат к разным модулям)
      const ss = selectedStatuses.filter((v, i, a) => a.indexOf(v) === i) // получаем все уникальные статусы
      const sm = selectedModule.filter((v, i, a) => a.indexOf(v) === i) // получаем все уникальные статусы

      if (ss.length === 1) {
        setSelectedStatus(ss[0])
      }
      if (sm.length === 1) {
        setSelectedSpecId(sm[0])
      }
    })()
  }, [checkedData])

  const validateSegments = () => {
    // При нажатии на кнопку проверяем, какие сегменты были выбраны
    // По-нормальному, надо запрашивать данные через API, а не брать их из стейта.
    const selectedStatuses = []
    const selectedModule = []

    // Собираем нужные массивы данных(статусы, модули, статусы проверки, эксперты)
    Object.keys(checkedData).map((id, key) => {
      selectedStatuses.push(checkedData[id].statusId)
      if (checkedData[id].type === 'test') { selectedModule.push(checkedData[id].test.moduleId) } else { selectedModule.push(checkedData[id].case.moduleId) }
    })

    // Обрабатываем ошибки (сегменты находятся в разных статусах, принадлежат к разным модулям)
    const ss = selectedStatuses.filter((v, i, a) => a.indexOf(v) === i) // получаем все уникальные статусы
    if (ss.length > 1) { setSegmentErrors(segmentErrors => [...segmentErrors, 'Сегменты находятся в разных статусах']) } else { setSelectedStatus(ss['0']) }

    const sm = selectedModule.filter((v, i, a) => a.indexOf(v) === i) // получаем все уникальные статусы

    if (sm.length > 1) {
      setSegmentErrors(segmentErrors => [...segmentErrors, 'Сегменты относятся к разным модулям'])
    } else {
      setSelectedSpecId(sm[0])
    }

    setOpen(true)

    return segmentErrors.length === 0
  }

  const handleClose = () => {
    setOpen(false)
    clearErrors()
    setCurrentUserId(0)
  }

  const openWarning = () => {
    setShowWarning(true)
  }

  const closeWarning = () => {
    setShowWarning(false)
    clearErrors()
  }

  const handleConfirm = () => {
    checkNewExpert().then(
      result => {
        if (!result.result) {
          confirm()
          handleClose()
        } else {
          setWarningContent(result.error.map((i, key) => <p key={key}>{i}</p>))
          openWarning()
        }
      }
    )
  }
  const confirmInWarning = () => {
    confirm()
    handleClose()
    closeWarning()
  }

  const clearErrors = () => {
    setWarningContent([])
    setSegmentErrors([])
  }

  const assignExpert = async (statusId, successText: boolean | string = false) => {
    if (currentUserId > 0) {
      await dataProvider(ASSIGN_EXPERT, 'segments', {
        segmentId: segmentsId,
        data: {
          toUserId: currentUserId,
          status: 'assign',
          segmentStatusId: statusId // id assign
        }
      }, successText ? {
        onSuccess: {
          notification: { body: successText, level: 'info' },
        },
        onFailure: {
          notification: { body: 'Error', level: 'warning' },
        },
        refresh: true
      } : responseSuccess)
    } else {
      dispatch(showNotification('Эксперт не выбран', 'warning'))
    }
  }

  const checkNewExpert = async () => {
    const newExpert = currentUserId

    const error = []
    let checked = false

    const segmentInfo = await dataProvider(GET_LIST, 'segments', {
      filter: { id: segmentsId.join(',') },
      url: 'segments'
    })

    segmentInfo.data.map((segment, key) => {
      segment.experts.map(item => {
        if (item.id as number == newExpert as number) {
          checked = true
          error.push(`Данный пользователь уже проверял сегмент №${segment.id}, подтвердите повторное назначение эксперта.`)
        }
      })
      if (segment.verifyStatusId === 2) { error.push(`Cегмент №${segment.id} находится в работе, вы уверены что хотите его переназначить?`) }
    })

    return {
      result: checked,
      error,
    }
  }

  const confirm = () => {
    if (selectedAction === 1) { assignExpert(nextStatus, 'Сохранено') } else { assignExpert(selectedStatus, 'Сохранено') }
  }

  return (
    <>
      {role === 'admin' && (<ToolbarDirectorMo
          dispatch={dispatch}
          statusId={selectedStatus}
          specializationId={selectedSpecId}
          disabled={assignButtonDisabled}
          users={users}
          segments={segmentsId}
          checkedData={checkedData}
          validateSegments={validateSegments}
          segmentErrors={segmentErrors}/>
      )}

      {role === 'managerMo' && (<ToolbarManagerMo
          dispatch={dispatch}
          statusId={selectedStatus}
          specializationId={selectedSpecId}
          disabled={assignButtonDisabled}
          users={users}
          segments={segmentsId}
          checkedData={checkedData}
          validateSegments={validateSegments}
          segmentErrors={segmentErrors}/>
      )}

      {role === 'directorMo' && (<ToolbarDirectorMo
          dispatch={dispatch}
          statusId={selectedStatus}
          specializationId={selectedSpecId}
          disabled={assignButtonDisabled}
          users={users}
          segments={segmentsId}
          checkedData={checkedData}
          validateSegments={validateSegments}
          segmentErrors={segmentErrors}/>
      )}

      {role === 'expertDeveloper' && (<ToolbarDeveloper
          dispatch={dispatch}
          statusId={selectedStatus}
          specializationId={selectedSpecId}
          disabled={assignButtonDisabled}
          users={users}
          segments={segmentsId}
          checkedData={checkedData}
          validateSegments={validateSegments}
          segmentErrors={segmentErrors}/>
      )}

      {role === 'expertReviewer' && (<ToolbarDeveloper
          dispatch={dispatch}
          statusId={selectedStatus}
          specializationId={selectedSpecId}
          disabled={assignButtonDisabled}
          users={users}
          segments={segmentsId}
          checkedData={checkedData}
          validateSegments={validateSegments}
          segmentErrors={segmentErrors}/>
      )}

      {role === 'methodist' && (<ToolbarMethodist
          dispatch={dispatch}
          statusId={selectedStatus}
          specializationId={selectedSpecId}
          disabled={assignButtonDisabled}
          users={users}
          segments={segmentsId}
          checkedData={checkedData}
          validateSegments={validateSegments}
          segmentErrors={segmentErrors}/>
      )}

      <Dialog open={segmentErrors.length > 0 && open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle>Ошибка! Невозможно назначить одного эксперта для выбранных сегментов.</DialogTitle>
        <DialogContent>
          {segmentErrors.map((i, key) => <p key={key}>{i}</p>)}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
                    Отмена
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={open && !(segmentErrors.length > 0)} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle>{modalLabel}</DialogTitle>
        <DialogContent>
          {download ? <Typography style={{ textAlign: 'center', padding: '20px 0' }}>Загрузка...</Typography> : (
            <UsersSelect data={users} onChange={setCurrentUserId} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
                    Отмена
          </Button>
          <Button onClick={handleConfirm} color="primary" disabled={currentUserId === 0}>
            {modalLabel}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showWarning && open && !(segmentErrors.length > 0)} onClose={closeWarning} aria-labelledby="form-dialog-title">
        <DialogTitle>Подтвердите действие</DialogTitle>
        <DialogContent>
          {warningContent}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeWarning} color="primary">
            Отмена
          </Button>
          <Button onClick={confirmInWarning} color="primary">
            ОК
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
})

export default withDataProvider(DashboardToolbarProvider)
